import { Selector, createSelector } from "reselect";

import { Filter, notTaggedFilter } from "constants/filters";
import { Right } from "constants/right";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'alphabeticalSortBySelector' is declared but its v... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { alphabeticalSortBySelector } from "helpers/sort";
import { IStoreState } from "interfaces/storeState";
import { IWithAgentsState, selectAgents } from "store/entities/agents";
import { ICustomView, ICustomViewWithStatus } from "store/entities/custom-views/interfaces";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'IEntityCollectionState' is declared but its value... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IEntityCollectionState } from "store/entities/reducer";
import { selectTags } from "store/entities/tags";
import { selectTeams } from "store/entities/teams";
import { IWithSessionState, hasRight } from "store/features/session";

import { ICustomViewState } from "./reducer";

export interface IWithCustomViewsState {
  entities: {
    customViews: ICustomViewState;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectCustomViews(state: IWithCustomViewsState) {
  return state.entities.customViews;
}

export const selectCustomViewsAlphabetically = createSelector(selectCustomViews, views =>
  views.order.map(viewID => views.data[viewID])
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const isMissingFilter = (customViewfilters: any, filter: Filter, filterValues: any) => {
  const isMyTeamsFilter =
    filter === Filter.Group &&
    customViewfilters[filter] &&
    customViewfilters[filter].length === 1 &&
    customViewfilters[filter][0] === "MY_TEAMS";

  const values = { ...filterValues };

  if (filter === Filter.Agent) {
    values.ME = {};
  }

  if (isMyTeamsFilter) {
    return false;
  }

  if (Array.isArray(customViewfilters[filter])) {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return customViewfilters[filter].some((value: any) => values[value] === undefined);
  }

  return customViewfilters[filter] && filterValues[customViewfilters[filter]] === undefined;
};

export const selectCustomViewsWithStatusAlphabetically: Selector<IStoreState, ICustomViewWithStatus[]> = createSelector(
  [selectCustomViewsAlphabetically, selectTags, selectTeams, selectAgents],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (customViews: any, tags: any, teams: any, agents: any) => {
    const tagsWithNotTagged = {
      ...tags,
      [notTaggedFilter.id]: notTaggedFilter,
    };

    return customViews.map((customView: ICustomView) => {
      const isInvalid =
        isMissingFilter(customView.filters, Filter.Tag, tagsWithNotTagged) ||
        isMissingFilter(customView.filters, Filter.Agent, agents) ||
        isMissingFilter(customView.filters, Filter.Group, teams);

      return { ...customView, invalid: isInvalid };
    });
  }
);
export function selectCanCreateCustomViews(
  state: IWithCustomViewsState & IWithSessionState & IWithAgentsState
): boolean {
  return hasRight(state, Right.CreateCustomViews);
}

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'state' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function selectCanSeeCustomViews(state: IWithCustomViewsState & IWithSessionState): boolean {
  return true;
}
